module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "modal-card-head display-flex"
  }, [_c('p', {
    staticClass: "flex-1"
  }, [(_vm.id) ? _c('span', [_vm._v("Editar delegacion ID - " + _vm._s(_vm.id))]) : _c('span', [_vm._v("Crear delegacion")])]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "contenedor-datos"
  }, [_c('div', {
    staticClass: "fechas"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('label', [_vm._v("Desde")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fechaInicio),
      expression: "fechaInicio"
    }],
    staticClass: "input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.fechaInicio)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fechaInicio = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "control"
  }, [_c('label', [_vm._v("Hasta")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fechaFin),
      expression: "fechaFin"
    }],
    staticClass: "input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.fechaFin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fechaFin = $event.target.value
      }
    }
  })])]), (!_vm.isCreatingSelf) ? _c('div', {
    staticClass: "codigo-empleado"
  }, [_c('label', [_vm._v("Empleado")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.codigoEmpleadoOrigen),
      expression: "codigoEmpleadoOrigen"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "disabled": _vm.id != 0
    },
    domProps: {
      "value": (_vm.codigoEmpleadoOrigen)
    },
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaEmpleadoOrigen = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.codigoEmpleadoOrigen = $event.target.value
      }
    }
  }), (!_vm.id) ? _c('div', {
    staticClass: "erase-data",
    on: {
      "click": function($event) {
        _vm.codigoEmpleadoOrigen = ''
      }
    }
  }, [_vm._m(0)]) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaEmpleadoOrigen) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-small-empleado', {
    attrs: {
      "codigo": _vm.codigoEmpleadoOrigen
    },
    on: {
      "selected": _vm.seleccionarEmpleadoOrigen,
      "close": function($event) {
        _vm.mostrarBusquedaEmpleadoOrigen = false
      }
    }
  })], 1) : _vm._e()])], 1)]) : _vm._e(), _c('div', {
    staticClass: "codigo-empleado pt-10"
  }, [_c('label', [_vm._v("Reemplazante")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.codigoEmpleadoReemplazante),
      expression: "codigoEmpleadoReemplazante"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.codigoEmpleadoReemplazante)
    },
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaEmpleadoReemplazante = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.codigoEmpleadoReemplazante = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "erase-data",
    on: {
      "click": function($event) {
        _vm.codigoEmpleadoReemplazante = ''
      }
    }
  }, [_vm._m(1)]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaEmpleadoReemplazante) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-small-empleado', {
    attrs: {
      "codigo": _vm.codigoEmpleadoReemplazante
    },
    on: {
      "selected": _vm.seleccionarEmpleadoReemplazante,
      "close": function($event) {
        _vm.mostrarBusquedaEmpleadoReemplazante = false
      }
    }
  })], 1) : _vm._e()])], 1)])])]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item is-success",
    on: {
      "click": _vm.guardar
    }
  }, [(_vm.isSaving) ? _c('span', [_vm._v("Guardando...")]) : _c('span', [_vm._v("Guardar")])]), _c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('strong', [_vm._v("Cancelar")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "fa fa-times"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "fa fa-times"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f79d4b30","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_gestion_delegaciones_rrhh_guardar.vue
// module id = 970
// module chunks = 0